import "../Styles/Pages/Register.css";
import { registerClass } from "../APIService";
import { useContext, useState } from "react";
import { ZGAContext } from "../ZGAContext";
import { feesData } from "../Assets/Data/FeesData";

const Register = () => {
  const { showRSModal, setIsSubmitting } = useContext(ZGAContext);
  const [selectedClass, setSelectedClass] = useState("");
  const [schedule, setSchedule] = useState("");
  const [currency, setCurrency] = useState("");
  const [cost, setCost] = useState("");
  const [students, setStudents] = useState([
    {
      id: 1,
      sFirstName: "",
      sLastName: "",
      dateOfBirth: "",
      pgFirstName: "",
      pgLastName: "",
      streetAddress: "",
      lga: "",
      state: "",
      phone: "",
      email: "",
    },
  ]);

  function handleClassChange(e) {
    const selected = e.target.value;
    setSelectedClass(selected);
    setSchedule("");
    setCurrency("");
    setCost("");
    setStudents(
      Array.from({ length: feesData[selected]?.numStudents || 1 }, (_, index) => ({
        id: index + 1,
        sFirstName: "",
        sLastName: "",
        dateOfBirth: "",
        pgFirstName: "",
        pgLastName: "",
        streetAddress: "",
        lga: "",
        state: "",
        phone: "",
        email: "",
      }))
    );
  }
  function handleScheduleChange(e) {
    const selectedSchedule = e.target.value;
    setSchedule(selectedSchedule);
    if (feesData[selectedClass] && feesData[selectedClass][selectedSchedule]) {
      setCurrency("");
      const num = feesData[selectedClass][selectedSchedule]?.numStudents || 1;
      setStudents(
        Array.from({ length: num }, (_, index) => ({
          id: index + 1,
          sFirstName: "",
          sLastName: "",
          dateOfBirth: "",
          pgFirstName: "",
          pgLastName: "",
          streetAddress: "",
          lga: "",
          state: "",
          phone: "",
          email: "",
        }))
      );

      updateCost(selectedClass, selectedSchedule, currency);
    }
  }
  function handleCurrencyChange(e) {
    const selectedCurrency = e.target.value;
    setCurrency(selectedCurrency);

    if (feesData[selectedClass] && feesData[selectedClass][schedule] && feesData[selectedClass][schedule].fee) {
      setCost(feesData[selectedClass][schedule].fee[selectedCurrency] || "");
    } else {
      setCost("");
    }
  }
  function updateCost(className, schedule, currency) {
    if (feesData[className] && feesData[className][schedule]) {
      setCost(feesData[className][schedule][currency] || "");
    } else {
      setCost("");
    }
  }
  function handleStudentChange(index, field, value) {
    const updatedStudents = [...students];
    updatedStudents[index][field] = value;
    setStudents(updatedStudents);
    console.log(students);
  }

  const handleRegister = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const formattedClassName = selectedClass.replace(/\s+/g, "");
    try {
      for (const student of students) {
        const registerInfo = {
          className: formattedClassName,
          schedule,
          currency,
          fee: cost,
          ...student,
        };
        console.log("Registering student:", registerInfo);
        const response = await registerClass(registerInfo);
        console.log("Response:", response.data);
      }
      showRSModal(true, "Student registration successful!", { currency, fee: cost });
    } catch (error) {
      showRSModal(false, error.response?.data?.message || "An error occurred during registration.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="register">
      <h1>REGISTRATION FORM</h1>
      <form onSubmit={handleRegister}>
        <fieldset className="class">
          <label>
            <span>Class you want to apply for</span>
            <select name="className" value={selectedClass} required onChange={handleClassChange}>
              <option value="">...Select Class...</option>
              {Object.keys(feesData).map((className) => (
                <option key={className} value={className}>
                  {className}
                </option>
              ))}
            </select>
          </label>
          {selectedClass && (
            <>
              <label>
                <span>Schedule</span>
                <select name="schedule" value={schedule} required onChange={handleScheduleChange}>
                  <option value="">...Select Schedule...</option>
                  {Object.keys(feesData[selectedClass] || {})
                    .filter((key) => key !== "numStudents")
                    .map((scheduleOption) => (
                      <option key={scheduleOption} value={scheduleOption}>
                        {scheduleOption}
                      </option>
                    ))}
                </select>
              </label>
              <label>
                <span>Currency</span>
                <select name="currency" value={currency} required onChange={handleCurrencyChange}>
                  <option value="">...Select Currency...</option>
                  {selectedClass &&
                    schedule &&
                    feesData[selectedClass]?.[schedule]?.fee &&
                    Object.keys(feesData[selectedClass][schedule].fee).map((cur) => (
                      <option key={cur} value={cur}>
                        {cur}
                      </option>
                    ))}
                </select>
              </label>
              <label>
                <span>Cost</span>
                <input type="text" value={cost} readOnly />
              </label>
            </>
          )}
        </fieldset>
        {students.map((student, index) => (
          <fieldset key={student.id} className="studentSection">
            <h3>Student {index + 1}</h3>
            <label>
              <span>Student Name</span>
              <span>
                <input
                  type="text"
                  name="sFirstName"
                  placeholder="First Name"
                  required
                  value={student.sFirstName}
                  onChange={(e) => handleStudentChange(index, "sFirstName", e.target.value)}
                />
                <input
                  type="text"
                  name="sLastName"
                  placeholder="Last Name"
                  required
                  value={student.sLastName}
                  onChange={(e) => handleStudentChange(index, "sLastName", e.target.value)}
                />
              </span>
            </label>
            <label>
              <span>Student Date of Birth</span>
              <input
                type="date"
                name="dateOfBirth"
                required
                value={student.dateOfBirth}
                onChange={(e) => handleStudentChange(index, "dateOfBirth", e.target.value)}
              />
            </label>
            <label>
              <span>Parent/ Guardian Name</span>
              <span>
                <input
                  type="text"
                  name="pgFirstName"
                  placeholder="First Name"
                  required
                  value={student.pgFirstName}
                  onChange={(e) => handleStudentChange(index, "pgFirstName", e.target.value)}
                />
                <input
                  type="text"
                  name="pgLastName"
                  placeholder="Last Name"
                  required
                  value={student.pgLastName}
                  onChange={(e) => handleStudentChange(index, "pgLastName", e.target.value)}
                />
              </span>
            </label>
            <label>
              <span>Current Address</span>
              <span>
                <input
                  type="text"
                  name="streetAddress"
                  placeholder="Street Address"
                  required
                  value={student.streetAddress}
                  onChange={(e) => handleStudentChange(index, "streetAddress", e.target.value)}
                />
                <input
                  type="text"
                  name="lga"
                  placeholder="LGA"
                  required
                  value={student.lga}
                  onChange={(e) => handleStudentChange(index, "lga", e.target.value)}
                />
                <input
                  type="text"
                  name="state"
                  placeholder="State"
                  required
                  value={student.state}
                  onChange={(e) => handleStudentChange(index, "state", e.target.value)}
                />
              </span>
            </label>
            <label>
              <span>Phone Number</span>
              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                required
                value={student.phone}
                onChange={(e) => handleStudentChange(index, "phone", e.target.value)}
              />
            </label>
            <label>
              <span>Email Address</span>
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                required
                value={student.email}
                onChange={(e) => handleStudentChange(index, "email", e.target.value)}
              />
            </label>
          </fieldset>
        ))}
        <input type="submit" name="submit" value="Continue" />
      </form>
    </div>
  );
};

export default Register;
